import { handleError } from "@common/components/helpers/error";
import CustomerClient from "@common/api/CustomerClient";
import IdentityFormModalAction from "@common/redux/actions/IdentityFormModalAction";

const fetchIdentityOptions = () => {
  IdentityFormModalAction.setLoadingIdentityOptions(true).then(() =>
    CustomerClient.MetaData()
      .then((identityFormOptions) => {
        IdentityFormModalAction.dispatch({ identityFormOptions });
      })
      .catch((error) => {
        console.error(error);
        handleError(error);
      })
      .finally(() => IdentityFormModalAction.setLoadingIdentityOptions(false)),
  );
};

export default fetchIdentityOptions;
